<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2020-08-11 15:01:49
 * @LastEditTime: 2022-04-22 11:53:41
 * @FilePath: \raacfold\src\components\BaimoFooter1.vue
-->
<template>
    <div class="footer-light">
        <!--<div class="col-md-1" style="margin: 5px;">-->
            <!--<iframe style="background:transparent !important" scrolling="no" frameborder="0" allowtransparency="true" width="40" height="40" src="//rf.revolvermaps.com/w/3/j/a/c2.php?i=5isjlx2f7l4&amp;b=0&amp;s=40&amp;m=2&amp;cl=ffffff&amp;co=010020&amp;cd=aa0000&amp;v0=60&amp;v1=60&amp;r=1"></iframe>-->
            <!--&lt;!&ndash;<script type="text/javascript" src="//rf.revolvermaps.com/0/0/3.js?i=5isjlx2f7l4&amp;b=0&amp;s=40&amp;m=2&amp;cl=ffffff&amp;co=010020&amp;cd=aa0000&amp;v0=60&amp;v1=60&amp;r=1" async="async"></script>&ndash;&gt;-->
        <!--</div>-->
        <small>© Copyright 2022 <a href="https://smkxxy.imu.edu.cn/" target="_blank">College of life sciences， Inner Mongolia University, Hohhot, 010021, China</a> | <a href="#">Top</a> </small>
    </div>
</template>

<script>
    export default {
        name: "Footer2"
    }
</script>

<style scoped>
    .footer-light {
        height: 4em;
        text-align: center;
        line-height: 38px;
        /*margin-top: 50px;*/
        background: #f8f8f8;
        border-top: 1px solid #e7e7e7;
        border-bottom: 1px solid #e7e7e7;
        height: 40px;
    }

    .footer-dark {
        color: white;
        height: 4em;
        text-align: center;
        line-height: 40px;
        /*margin-top: 50px;*/
        background: #545C64;
        border-top: 0px solid #e7e7e7;
        border-bottom: 0px solid #e7e7e7;
        height: 40px;
    }

    .footer-dark a {
        color: #FFD04B
    }
</style>
